const ANAYA_SOCIAL_URLS: Record<string, string> = {
  instagram: "https://www.instagram.com/anayaperfume/",
  facebook: "https://www.facebook.com/anayaperfume/",
  tiktok: "https://www.tiktok.com/@anayaperfume/",
  youtube: "https://www.youtube.com/@anayaperfume",
};

const TRACKING_PARAMS = [
  "fbclid",
  "igsh",
  "mibextid",
  "si",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const toHttpsUrl = (value: string) => {
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("@")) return value;
  return `https://${value}`;
};

const cleanUrl = (url: URL) => {
  TRACKING_PARAMS.forEach((param) => url.searchParams.delete(param));
  url.hash = "";
  return url;
};

export const sanitizeSocialUrl = (platform: string, rawUrl: string | null | undefined) => {
  const fallback = ANAYA_SOCIAL_URLS[platform.toLowerCase()];
  const trimmed = rawUrl?.trim();

  if (!trimmed) return "";

  try {
    if (trimmed.startsWith("@")) {
      const handle = trimmed.slice(1).replace(/\/$/, "");
      if (platform === "instagram") return `https://www.instagram.com/${handle}/`;
      if (platform === "tiktok") return `https://www.tiktok.com/@${handle}/`;
      if (platform === "youtube") return `https://www.youtube.com/@${handle}`;
      if (platform === "facebook") return `https://www.facebook.com/${handle}/`;
    }

    const url = cleanUrl(new URL(toHttpsUrl(trimmed)));
    const host = url.hostname.toLowerCase().replace(/^m\./, "www.");
    const segments = url.pathname.split("/").filter(Boolean);

    if (platform === "instagram" && host.endsWith("instagram.com")) {
      const username = segments[0];
      if (!username || ["p", "reel", "share", "stories", "explore"].includes(username)) return fallback;
      return `https://www.instagram.com/${username}/`;
    }

    if (platform === "facebook" && host.endsWith("facebook.com")) {
      if (segments[0] === "profile.php" && url.searchParams.get("id")) {
        return `https://www.facebook.com/profile.php?id=${encodeURIComponent(url.searchParams.get("id") ?? "")}`;
      }
      const page = segments[0];
      if (!page || ["share", "sharer", "dialog", "login", "search"].includes(page)) return fallback;
      return `https://www.facebook.com/${page}/`;
    }

    if (platform === "youtube" && (host.endsWith("youtube.com") || host.endsWith("youtu.be"))) {
      const channel = segments[0]?.startsWith("@") ? segments[0] : fallback?.split("/").pop();
      return channel ? `https://www.youtube.com/${channel}` : url.toString();
    }

    if (platform === "tiktok" && host.endsWith("tiktok.com")) {
      const handle = segments.find((segment) => segment.startsWith("@"));
      return handle ? `https://www.tiktok.com/${handle}/` : fallback;
    }

    return url.toString();
  } catch {
    return fallback || trimmed;
  }
};

export const openExternalSocialUrl = (event: { preventDefault: () => void }, url: string) => {
  event.preventDefault();
  const opened = window.open(url, "_blank", "noopener,noreferrer");

  if (!opened) {
    window.location.assign(url);
  }
};